export function useSlideTitle() {
  return `Correlation Crude Oil and Crop Price Index`;
}